import DB from '../../../private/db';
import { IPatchStorage, IPatchStorageOptions } from './interface';

const TABLE_NAME = 'IPatchStorage';
const TABLE_MAPPINGS = 'name, hash, data';

function _db(options: IPatchStorageOptions = {}): DB {
    const db = new DB({
        version: 1,
        mappings: {
            [TABLE_NAME]: TABLE_MAPPINGS,
        },
        name: options.name ?? TABLE_NAME,
        indexedDB: options.indexedDB,
        IDBKeyRange: options.IDBKeyRange,
    });

    return db;
}

function load(name: string, options: IPatchStorageOptions = {}): Promise<IPatchStorage> {
    return new Promise(async function (resolve, reject) {
        try {
            const db = _db(options);

            await db.open();

            const table = db.table(TABLE_NAME);

            const result: IPatchStorage = await table.get(name);

            db.close();

            result ? resolve(result) : reject('Unable to find patch-storage named: ' + name);
        } catch (error) {
            reject(error);
        }
    });
}

function save(data: IPatchStorage, options: IPatchStorageOptions = {}): Promise<void> {
    return new Promise(async function (resolve, reject) {
        try {
            const db = _db(options);

            await db.open();

            const table = db.table(TABLE_NAME);

            const result = await table.put(data);

            db.close();

            result === data.name
                ? resolve()
                : reject('Failed to save data into patch-storage table');
        } catch (error) {
            reject(error);
        }
    });
}

function remove(name: string, options: IPatchStorageOptions = {}): Promise<void> {
    return new Promise(async function (resolve, reject) {
        try {
            const db = _db(options);

            await db.open();

            const table = db.table(TABLE_NAME);

            await table.delete(name);

            db.close();

            resolve();
        } catch (error) {
            reject(error);
        }
    });
}

export default {
    load,
    save,
    remove,
};
